import { el, clear } from '../../utils/dom.js';
import { Rentals, Clients } from '../../api/resources.js';
import { field, readForm } from '../../components/form.js';
import { LineEditor } from '../../components/line-editor.js';
import { ok, err } from '../../components/toast.js';
import { navigate } from '../../router/index.js';

export default async function RentalsFormPage(outlet) {
  clear(outlet);
  let clients = [];
  try { clients = (await Clients.list({ limit: 500 })).data || []; }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('h1', {}, 'Nueva renta'),
    el('a', { href: '#/rentals', class: 'btn ghost' }, '← Volver'),
  ));

  const lineEditor = LineEditor({ withPrice: true, onlyAvailable: false });

  const now = new Date();
  const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      const data = readForm(form);
      const items = lineEditor.getLines();
      const v = lineEditor.validate();
      if (v) { err(v); return; }
      try {
        const created = await Rentals.create({
          client_id: data.client_id,
          start_date: new Date(data.start_date).toISOString(),
          end_date: new Date(data.end_date).toISOString(),
          // Solo cotizar no aparta los equipos; si no, se apartan con candado (sin dobles reservas).
          status: data.cotizar ? 'cotizada' : 'reservada',
          discount: Number(data.discount || 0),
          tax: Number(data.tax || 0),
          deposit: Number(data.deposit || 0),
          notes: data.notes || undefined,
          items,
        });
        ok(`Renta ${created.code} creada`);
        navigate(`/rentals/${created.id}`);
      } catch (ex) { err(ex.message); }
    },
  });

  const card = el('div', { class: 'card mb-4' });
  const grid = el('div', { class: 'form-grid' });
  grid.append(
    field({ name: 'client_id', label: 'Cliente', type: 'select', required: true,
      options: clients.map((c) => ({ value: c.id, label: `${c.full_name}${c.document_id ? ' · ' + c.document_id : ''}` })) }),
    field({ name: 'cotizar', label: 'Solo cotizar (no aparta los equipos todavía)', type: 'checkbox', value: false }),
    field({ name: 'start_date', label: 'Entrega', type: 'datetime-local', required: true, value: toLocalInput(now) }),
    field({ name: 'end_date',   label: 'Devolución',    type: 'datetime-local', required: true, value: toLocalInput(tomorrow) }),
    field({ name: 'discount', label: 'Descuento', type: 'number', step: '0.01', value: 0 }),
    field({ name: 'tax',      label: 'Impuesto',  type: 'number', step: '0.01', value: 0 }),
    field({ name: 'deposit',  label: 'Depósito de garantía',  type: 'number', step: '0.01', value: 0 }),
    field({ name: 'notes',    label: 'Notas', type: 'textarea', full: true }),
  );
  card.appendChild(grid);
  form.appendChild(card);

  form.appendChild(lineEditor.root);
  form.appendChild(el('p', { class: 'muted text-sm mb-4' }, 'Deja el precio en 0 para usar el precio del equipo y sus tarifas por duración. Un combo aparta todos sus equipos.'));

  form.appendChild(el('div', { class: 'flex gap-2 justify-between' },
    el('a', { href: '#/rentals', class: 'btn' }, 'Cancelar'),
    el('button', { class: 'btn primary', type: 'submit' }, 'Crear renta'),
  ));
  outlet.appendChild(form);
}

function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
